"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ECDSA;
(function (ECDSA) {
    ECDSA["ed25519"] = "ed25519";
    ECDSA["secp256k1"] = "ecdsa-secp256k1";
})(ECDSA || (ECDSA = {}));
exports.default = ECDSA;
//# sourceMappingURL=ECDSA.js.map